import { BookingAppointment } from './BookingAppointment';

export type ServiceRequest = {
  id?: string;
  description: string;
  status?: string;
  supportTopicId?: string;
  supportTopicName: string;
  supportTopicDescription?: string;
  primaryContact: Contact;
  title: string;
  severity: ServiceRequestSeverity;
  fileLinks: FileInfo[];
  newNote?: Note;
  organization?: { name?: string; id?: string };
  createdDate?: string;
  lastModifiedDate?: string;
  lastClosedDate?: string;
  notes?: Note[];
  countryCode?: string;
  emailCcList: string[];
  additionalInfo?: AdditionalInfo[];
  appointment?: BookingAppointment;
  appointmentEligible?: boolean;
};

export enum ServiceRequestSeverity {
  Unknown = 0,
  Critical = 1,
  Moderate = 2,
  Minimal = 3,
}

export type Contact = {
  firstName?: string;
  lastName?: string;
  email: string;
  phoneNumber: string;
};

export type Note = {
  text: string;
  createdByName?: string;
  createdDate?: string;
  updatedByName?: string;
};

export type AttachmentsInfo = {
  workspaceId: string;
  attachments: Array<FileInfo>;
};

export type FileInfo = {
  comment?: string;
  extensionType?: string;
  fileNameWithoutExtension?: string;
  fileSize?: number;
  id?: any;
  location?: string;
  lastUpdatedInUTC?: string;
};
export type AdditionalInfo = {
  type: string;
  payLoad: object;
};
